// @ts-nocheck
import React from 'react';
import { Row } from 'antd';

// CUSTOM MODULES
import PageTitle from 'shared_components/page_title';
import { LabExamRequestIcon, UserMaintenanceIcon, NormalValuesIcon, Report } from 'images';
import DataAnalysisCard from './data_analysis_card';

import './index.css';

const settingsItemData = [
	{
		image: Report,
		link: '/data-analysis/quality-control',
		label: 'QUALITY CONTROL',
	},
	{
		image: Report,
		link: '/data-analysis/reports',
		label: 'REPORTS',
	},
];

class DataAnalysisMenu extends React.Component {
	render() {
		const rowItems = settingsItemData.map(el => {
			return (
				<DataAnalysisCard
					image={el.image}
					link={el.link}
					label={el.label}
					offset={el.offset}
					className=""
					key={el.label}
				/>
			);
		});

		return (
			<div>
				<PageTitle pageTitle="DATA ANALYSIS" />
				<div className="space-y-md"></div>
				<div className="menu-container">{rowItems}</div>
			</div>
		);
	}
}

export default DataAnalysisMenu;
